// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-rule {
  width: 240px;
  height: 0;
  border: 1px solid #cccccc;
}

.arrow-div {
  text-align: right;
  margin-right: 20px;
}

.arrow {
  color: #cc0000;
  cursor: pointer;
  height: 12px;
  width: 12px;
  stroke-width: 5px;
}

.format-checkboxes {
  transform: scale(1.3);
  accent-color: #b40000;
}

.checkbox {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 14px;
  border-color: #b40000;
  background-color: #cc0000;
}

.checkbox-label {
  margin-left: 8px;
  font-weight: bold;
  max-width: 155px;
  min-width: 155px;
}

.checkbox-count {
  color: #808080;
  margin-left: auto;
  margin-right: 15px;
}

.apply-button {
  margin: 20px 10px 20px 0;
  border: 2px solid #cc0000;
  color: #cc0000;
  background-color: #e5e5e5;
  padding: 4px 8px;
  width: 130px;
}

.analytics-button {
  border: 2px solid #1a1a1a;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

@media (max-width: 1024px) {
  .analytics-button {
    display: none;
  }
}

.clear-button {
  margin: 20px 0;
  border: 2px solid #1a1a1a;
  color: #000000;
  background-color: #e5e5e5;
  padding: 4px;
  width: 110px;
}

.more-span {
  font-weight: bold;
  color: #b40000;
  cursor: pointer;
}

@media (max-width:1024px) {
  .apply-clear-buttons {
    display: flex;
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/left-pane.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".horizontal-rule {\n  width: 240px;\n  height: 0;\n  border: 1px solid #cccccc;\n}\n\n.arrow-div {\n  text-align: right;\n  margin-right: 20px;\n}\n\n.arrow {\n  color: #cc0000;\n  cursor: pointer;\n  height: 12px;\n  width: 12px;\n  stroke-width: 5px;\n}\n\n.format-checkboxes {\n  transform: scale(1.3);\n  accent-color: #b40000;\n}\n\n.checkbox {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  height: 14px;\n  width: 14px;\n  border-color: #b40000;\n  background-color: #cc0000;\n}\n\n.checkbox-label {\n  margin-left: 8px;\n  font-weight: bold;\n  max-width: 155px;\n  min-width: 155px;\n}\n\n.checkbox-count {\n  color: #808080;\n  margin-left: auto;\n  margin-right: 15px;\n}\n\n.apply-button {\n  margin: 20px 10px 20px 0;\n  border: 2px solid #cc0000;\n  color: #cc0000;\n  background-color: #e5e5e5;\n  padding: 4px 8px;\n  width: 130px;\n}\n\n.analytics-button {\n  border: 2px solid #1a1a1a;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n@media (max-width: 1024px) {\n  .analytics-button {\n    display: none;\n  }\n}\n\n.clear-button {\n  margin: 20px 0;\n  border: 2px solid #1a1a1a;\n  color: #000000;\n  background-color: #e5e5e5;\n  padding: 4px;\n  width: 110px;\n}\n\n.more-span {\n  font-weight: bold;\n  color: #b40000;\n  cursor: pointer;\n}\n\n@media (max-width:1024px) {\n  .apply-clear-buttons {\n    display: flex;\n    flex-direction: row;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
